import React from 'react';

import {
	IconAlertCircle,
	IconChartBar,
	IconFileSearch,
	IconUserCheck
} from '@tabler/icons-react';

import { EditorialCategoryType } from '../models/enums';

export type CategoryProps = {
	id: number;
	icon: React.ComponentType;
	label: string;
	value: EditorialCategoryType;
};

export const Categories: CategoryProps[] = [
	{
		id: 11,
		icon: IconUserCheck,
		label: 'educationType',
		value: EditorialCategoryType.Education
	},
	{
		id: 12,
		icon: IconFileSearch,
		label: 'analysisType',
		value: EditorialCategoryType.Analysis
	},
	{
		id: 13,
		icon: IconAlertCircle,
		label: 'warningType',
		value: EditorialCategoryType.Warning
	},
	{
		id: 14,
		icon: IconChartBar,
		label: 'reviewType',
		value: EditorialCategoryType.Review
	}
];
